/* eslint-disable prettier */
/**
 * Created by calhosh on 4/14/2017.
 * FR CA resource file
 */
export const labels = {
	title: 'EY Canvas Economics',
	status: 'État',
	header: 'En-tête',
	canvas: 'Canvas',
	canvasEconomics: 'Données financières Canvas',
	badRequest: 'demande erronée',
	errorBanner: '{0} erreur(s)',
	userProfileDropdown: {
		myProfile: 'Mon profil',
		signOut: 'Se déconnecter'
	},
	clientCode: 'Code client',
	hours: 'Heures',
	local: 'Locale',
	currency: 'Devises',
	rate: 'Taux',
	forecast: 'Prévision',
	variance: 'Écart',
	edit: 'Modifier',
	arrowUp: 'Flèche vers le haut',
	budget: 'Budget',
	priorBudget: 'Budget précédent',
	currentBudget: 'Budget actuel',
	summary: 'Sommaire',
	actual: 'Réel',
	priorActual: 'Réel précédent',
	currentActual: 'Réel courant',
	remaining: 'Restant',
	adjustment: 'Ajustement',
	estimate: 'Estimation',
	isRequired: 'Le champ {0} est requis',
	isPositiveInteger: 'Le champ {0} est requis et doit contenir un nombre entier non négatif.',
	isPositiveDecimal: 'Le champ {0} est requis et doit contenir un nombre positif à 2 décimales.',
	in: 'Pour',
	id: 'Identifiant',
	currentYear: 'Exercice considéré',
	priorYear: 'Exercice précédent',
	budgetHierarchy: 'Hiérarchie du budget',
	executionBudgetHierarchy: 'Hiérarchie du budget relatif à l’exécution',
	noContentAvailable: 'Aucun contenu disponible',
	viewMore: 'Afficher plus',
	budgetExecutionPhase: 'Budget pour tous les objets contenus dans {0}',
	details: 'détails',
	unallocated: 'Non affecté',
	none: 'Aucun',
	thousands: 'Milliers',
	millions: 'Millions',
	lakhs: 'Lakhs',
	crores: 'Crores',
	budgetObjectName: 'Nom de l’objet budget',
	editActivityCodes: 'Modifier les codes d’activité',
	save: 'Enregistrer',
	send: 'Send',
	cancel: 'Annuler',
	searchActivityCodes: 'Rechercher des codes d’activité',
	noActivityCodesAvailable: 'Aucun code d’activité disponible',
	select: 'Sélectionner',
	engagementCode: 'Code mission',
	engagementCodeName: 'Engagement code name',
	activityCode: 'Code d’activité',
	activityCodeDescription: 'Description du code d’activité',
	searchActivityCodesPlaceholderText: 'Rechercher des codes d’activité',
	addMember: 'Ajouter un membre',
	closeLabel: 'Fermer',
	cancelLabel: 'Annuler',
	seachInputRequired: 'Entrer le texte recherché',
	nameOrEmail: 'Nom ou courriel',
	emailForExternal: 'Adresse courriel',
	noRecord: 'Aucun résultat trouvé',
	userSearchPlaceholder: 'Entrer le nom ou l’adresse courriel et appuyer sur la touche Entrée pour afficher les résultats.',
	userSearchPlaceholderForExternal: 'Entrer l’adresse courriel et appuyer sur la touche Entrée pour afficher les résultats.',
	clearAllValues: 'Effacer toutes les valeurs',
	clear: 'Effacer',
	inValidEmail: 'Veuillez entrer une adresse courriel valide',
	invalidClientCode: 'Code client invalide',
	railSearchText: 'Rechercher',
	open: 'Ouvrir',
	remove: 'Supprimer',
	leave: 'Quitter',
	delete: 'Supprimer',
	markAsCompleted: 'Indiquer comme étant terminé',
	budgetedHours: 'Heures budgétées',
	forecastedHours: 'Heures prévues',
	actualHours: 'Heures réelles',
	ftaVariance: 'Écart entre les prévisions et les données réelles',
	ftaVarianceTooltip: 'Écart entre les prévisions et les données réelles',
	usedHours: 'Heures utilisées',
	etcHours: "Nombre d'heures estimé avant l'achèvement?",
	createProjectCard: 'Créer un projet',
	plusClients: '+{0} clients',
	plusCodes: '+{0} codes client',
	clientNames: 'Noms de client :',
	clientName: 'Nom du client :',
	clientNameLabel: 'Client name',
	clientCodes: 'Codes client :',
	clientCodeCard: 'Code client :',
	financialAnalysis: 'Financial analysis',
	billingExpenses: 'Facturation et dépenses',
	independence: 'Independence',
	timeChargedCanvasIndependenceStatus: 'Overall Project Independence Status by EY Canvas and Financial Code',
	independenceStatusFromCanvasLabel:'Independence status from EY Canvas',
	independenceRequired: 'Independence required',
	validatedCanvas: 'Validated in EY Canvas',
	notInvited: 'Not invited',
	notApplicable: 'Not applicable',
	incomplete: 'Incomplete',
	other: "Other",
	financialCodesDisplayed: "Financial codes displayed",
	independenceStatusChangeReasonLabel: "Change status",
	independenceStatusChangeReasonDescription: "Select completion reason for selected team member",
	changeReasonLabel: 'Reason',
	clarificationLabel: 'Clarification (optional)',
	characterCount: '{0} of 200 characters',
	expandAll: "Expand all",
	collapseAll: "Collapse all",
	canvasEngagements: "EY Canvas engagements",
	independenceCompleted: 'Independence completed',
	engagementName: 'Engagement name',
	engagementIndependenceStatus: 'By engagement independence status',
	noAssociatedClients:'No associated client',
	noCanvasEngagementsIdentified:'No EY Canvas engagements identified',
	placeholderForSearch:'Search Team Member',
	exportToExcel: 'Export to Excel',
	all: 'All',
	updateSelected: 'Update selected',
	updateAll: 'Update all',
	customizeTable: 'Customize table',
	canvasEngagementName: 'EY Canvas engagement name',
	displayBy: 'Afficher les données par',
	financialDetails: 'Données financières',
	actualHoursToDate: "Heures réelles jusqu'à présent",
	byWeekEndingDate: 'selon la date du dernier jour de la semaine',
	ClickAndDrag: 'Cliquez sur une zone dans l’organigramme et faites-la glisser pour effectuer un zoom avant',
	etc: 'Délai d’exécution estimé',
	auditProgress: 'EY Canvas progress',
	tasksAndMilestones: 'Tâches et jalons',
	milestonesOverdue: 'Jalons en retard',
	milestoneOverdue: 'jalons en retard',
	inProgress: 'En cours',
	inReview: 'En cours de revue',
	Complete: 'Terminée',
	assignments: 'Affectations',
	assignment: 'affectations',
	assignmentsOverdue: 'Affectations en retard',
	assignmentOverdue: 'affectations en retard',
	overdue: 'en retard',
	requestOverdue: 'Demande en retard',
	requestsOverdue: 'demandes en retard',
	total: 'Total',
	complete: 'Terminée',
	closed: 'Fermées',
	Unassigned: 'Non attribuée',
	unassigned: 'non assignée',
	sent: 'Envoyée',
	totalTask: 'Nombre total de tâches',
	collaboration: 'Collaboration',
	received: 'Reçue',
	accepted: 'Acceptée',
	outstanding: 'En cours',
	unsentDrafts: 'Ébauches non envoyées',
	draft: 'Projet',
	drafts: 'projets',
	returned: 'returned',
	draftRequests: 'rédiger des demandes',
	percent: 'Pourcentage',
	preparer: 'Préparateur',
	reviewer: 'Responsable de la revue',
	NoDataForSelectedOptions: 'No information available for the selected options.',
	NoAssignmentDataForSelectedOptions: 'Engagement is not using the Assignment feature',
	NoCollabDataForSelectedOptions: 'La fonction de collaboration n’est pas utilisée pour cette mission',
	tasks: 'Tâches',
	totalTasks: 'tâches totales',
	requests: 'demandes',
	requestSent: 'demandes envoyées',
	requestsSent: 'Demandes envoyées',
	expandDetails: 'Afficher plus de détails',
	onlyProjectAdministratorsCanEdit: 'Seuls les administrateurs de projet peuvent modifier',
	onlyProjectAdministratorsCanDelete: 'Seuls les administrateurs de projet peuvent supprimer les projets',
	userOptions: 'Options de l’utilisateur',
	userOptionsDropdown: {
		userSettings: 'Paramètres de l’utilisateur',
		delegateAccess: 'Gérer les délégués',
		privacyNotice:'Privacy notice',
		signOut: 'Se déconnecter'
	},
	delegateToInstruction: 'Attribuez des droits d’accès à vos collègues, afin qu’ils puissent valider les codes de mission en votre nom. Les délégués sélectionnés pourront valider tous les codes de mission auxquels vous avez accès.',
	delegateFromInstruction: 'Les utilisateurs suivants ont délégué leurs droits d’accès pour la validation des codes de mission.',
	delegateAccess: 'Gérer les délégués',
	addDelegates: 'Ajouter des délégués',
	addAnother: 'Ajouter un nouveau délégué',
	hideMyDelegate: 'Masquer mes délégués',
	showMyDelegate: 'Afficher mes délégués',
	duplicateUser: 'Cette personne a déjà les droits d’accès',
	informationRequired: 'Cette information est requise',
	delegateTo: 'Délégué à',
	delegateFrom: 'Délégué par',
	noDelegatesAdded: 'Aucun délégué n’a été ajouté.',
	noDelegationReceived: "Aucun droit d’accès n'a été reçu.",
	removeDelegateMessgae: 'Voulez-vous vraiment retirer cette personne de la liste de vos délégués? Une fois qu’elle aura été retirée de la liste, elle ne pourra plus valider de codes de mission en votre nom.',
	removeDelegateTitle: 'Retirer un délégué',
	delegate: 'Déléguer',
	saveAndClose: 'Enregistrer et fermer',
	resetZoom: 'Reset zoom',
	exportData: 'Export data',
	rankCode: 'Rank code',
	userGui: 'User GUI',
	email: 'Email',
	globalAnsr: 'Global ANSR',
	globalCost: 'Global cost',
	globalMargin: 'Global margin',
	localAnsr: 'Local ANSR',
	localCost: 'Local cost',
	localMargin: 'Local margin',
	weekEnding: 'Week ending',
	welcomeToEconomics: 'Welcome to the EY Canvas Economics ',
	adminPortal: 'administrative portal',
	home: 'Home',
	enterFirstNameText:'Enter first name, last name or email address of user and press enter to search',
	addBtn: 'Ajouter',
	cancelBtn: 'Cancel',
	close: 'Fermer',
	selectRole: 'Role',
	upsText: 'Ups!',
	sufficientRightsToAccess: 'You do not have sufficient rights to access this page',
	detailedInformation : 'Detailed information may vary from summary data presented due to timing differences of when data is made available.',
	noResultFound: 'No results match the search criteria',
	loading: 'Loading...',
	search: 'Rechercher',
	softwareUpdate: 'Software updates',
	updateLater: 'Update later',
	updateNow: 'Update now',
	updateMsg: 'Software updates are available for EY Canvas Economics. Select Update Now to download and install the updates. The page will be refreshed.',
		
	eycanvasEngagements: 'EY Canvas engagements',
	eycanvasEngagement: 'EY Canvas engagement',
	expandView: 'Expand view',
	noFinancialCodesDisplay: 'No financial codes to display',
	expand: 'Développer',
	collapse: 'Collapse',
	bulkSendIndependenceLabel: 'Bulk send independence confirmation',
	independenceStatusInviteUserLabel: 'Add internal team member as Independence only',
	independenceStatusInviteUserDescription: "Identify the role of the team member below. This user will be added to {0} Canvas engagement with the 'Independence only' restrictions and will be notified to complete their Independence.",
	clickToInviteUser: 'to send independence confirmation',
	click: 'Click',
	invitePending:'Invite pending',
	engagementRolePlaceholder: 'Engagement role',
	engagementRoleRequiredErrorMessage: 'Please select the engagement role for the selected team member',
	engagementInvitationSuccessToastMessage: 'You have successfully sent the independence confirmation(s).',
	engagementInvitationFailureToastMessage: 'Failed to send the independence confirmation(s), Please retry. If issue persists, reach out to the Help desk.',
	independenceInviteConfirmationMessage: 'Independence confirmation has been sent. Response is pending.',
	engagementRoleRequiredOverAllErrorMessage: 'An engagement role has not been selected for one or more users. Select the engagement role from the drop down to proceed with sending the Independence confirmation.',
	administrativeContractor: 'Administrative contractor',
	notAvailable: 'Not Available',
	allocation: 'Allocation',
};

export const errors = {
	default: 'Une erreur s’est produite. Veuillez communiquer avec le Service de dépannage.',
	102: 'Projet invalide',
	106: 'Autorisation RBAC refusée.',

	1001: 'Utilisateur introuvable.',
	1002: 'Échec de l’appel de récupération de tous les utilisateurs.',
	1003: 'L’identificateur unique mondial (GUI) de l’utilisateur ne peut pas être nul.',
	1004: 'La demande ne peut être nulle.',
	1005: "L’utilisateur n’a pas pu être créé, car un utilisateur avec le même identificateur unique mondial (GUI) existe déjà.",
	1006: 'Plus d’un utilisateur avec le même identificateur unique mondial (GUI) a été trouvé.',
	1007: 'L’utilisateur n’est pas un membre actif. Veuillez actualiser la page et réessayer. Si l’erreur persiste, veuillez communiquer avec le Service de dépannage.',
	1008: 'Le format des nombres sélectionné n’est pas valide. Veuillez actualiser la page et réessayer. Si l’erreur persiste, veuillez communiquer avec le Service de dépannage.',
	1009: 'Le format du nombre arrondi sélectionné n’est pas valide. Veuillez actualiser la page et réessayer. Si l’erreur persiste, veuillez communiquer avec le Service de dépannage.',
	1010: 'Le format de la devise sélectionné n’est pas valide. Veuillez actualiser la page et réessayer. Si l’erreur persiste, veuillez communiquer avec le Service de dépannage.',
	1011: 'Le format de la date sélectionné n’est pas valide. Veuillez actualiser la page et réessayer. Si l’erreur persiste, veuillez communiquer avec le Service de dépannage.',
	1012: 'La langue sélectionnée n’est pas valide. Veuillez actualiser la page et réessayer. Si l’erreur persiste, veuillez communiquer avec le Service de dépannage.',
	1013: 'Le prénom est trop court ou trop long. Veuillez réessayer.',
	1014: 'Le nom de famille est trop court ou trop long. Veuillez réessayer.',
	1015: 'Le format des nombres négatifs sélectionné n’est pas valide. Veuillez actualiser la page et réessayer. Si l’erreur persiste, veuillez communiquer avec le Service de dépannage.',
	1016: "L’utilisateur ne peut pas être mis à jour, car il n’existe pas.",
	1017: "Une erreur s’est produite pendant la récupération des préférences de l’utilisateur. Échec de l'appel de l’interface de programmation.",
	1018: "Une erreur s’est produite lors de la création de l’utilisateur. Échec de l'appel de l’interface de programmation.",
	1019: "'Une erreur s'est produite lors de la mise à jour des préférences de l’utilisateur. Échec de l'appel de l’interface de programmation.",
	1020: 'L’utilisateur n’est pas un membre actif. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.',
	1021: 'La valeur du thème sélectionnée n’est pas valide. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.',
	1022: 'La valeur de la devise sélectionnée n’est pas valide. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.',
	1023: 'L’utilisateur n’est pas autorisé à retirer le membre de l’équipe requis du projet.',
	1024: "Une erreur s’est produite lors de la création de l’utilisateur délégué. Échec de l'appel de l’interface de programmation.",
	1025: 'La liste des utilisateurs délégués ne doit pas être vide.',
	1026: 'Le nom d’un utilisateur est trop long ou trop court.',
	1027: 'L’identificateur unique mondial (GUI) d’un utilisateur est invalide.',
	1028: 'L’adresse courriel d’un utilisateur est trop longue ou trop courte.',
	1029: 'Le champ de l’identifiant de l’utilisateur ne doit pas être vide.',
	1030: 'Le champ du nom de l’utilisateur ne doit pas être vide.',
	1031: 'Le champ de l’adresse courriel de l’utilisateur ne doit pas être vide.',
	1032: 'L’utilisateur ne figure pas dans la liste des délégués ayant les droits pour supprimer l’accès.',
	1033: 'L’utilisateur ne figure pas dans la liste des personnes ayant attribué des droits pour supprimer l’accès.',
	1034: 'L’utilisateur fait déjà partie des délégués de la collection.',
	1035: 'La longueur de l’identifiant de l’utilisateur n’est pas appropriée. Veuillez réessayer avec le bon identifiant de l’utilisateur.',
	1036: 'L’utilisateur connecté ne peut pas faire partie de la liste. Veuillez réessayer plus tard.',
	1040: 'You do not have administrator rights. Please contact the help desk.',

	7001: 'Échec de l’appel des métadonnées relatives aux missions.',
	7006: 'Vous ne pouvez pas accéder à EY Canvas pour le moment. Veuillez actualiser la page et réessayer. Si l’erreur persiste, veuillez communiquer avec le Service de dépannage.',

	8003: 'Error while getting Engagement Details from CDS API.',
	8006: 'Vous ne pouvez pas accéder à EY Canvas pour le moment. Veuillez actualiser la page et réessayer. Si l’erreur persiste, veuillez communiquer avec le Service de dépannage.',
	8004: 'Code mission introuvable. S’il s’agit d’un code Mercury, assurez-vous que le type de mission est inclus. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.',
	8007: 'Error while getting Engagement Details from CDS API.',
	8008: 'Connection failed. Refresh and try again. If the issue persists, contact the Help desk.',

	9001: 'La requête ne peut pas être nulle',
	9002: 'Le champ Code client du projet ne peut être vide',
	9003: 'Le champ Nom du projet ne peut pas être vide.',
	9004: 'Le champ Pourcentage ne peut pas être vide.',
	9005: 'Le champ Taux ne peut pas être vide.',
	9006: 'Le budget n’est associé à aucune mission sélectionnée.',
	9007: 'L’identifiant unique de la mission ne peut pas être nul.',
	9008: 'Le nom du client d’audit ne peut pas être nul.',
	9009: 'La description de la mission ne peut pas être nulle.',
	9010: 'L’identifiant unique du client d’audit ne peut pas être nul.',
	9011: 'Le système de mission associé ne peut pas être nul.',
	9012: 'L’identifiant unique de la mission associée ne peut pas être nul.',
	9013: 'Le nom de la mission associée ne peut pas être nul.',
	9014: 'L’identifiant unique du client d’audit associé ne peut pas être nul.',
	9015: 'Le nom du client d’audit associé ne peut pas être nul.',
	9016: 'La mission associée ajoutée par ne peut pas être nulle.',
	9017: 'One or more EY Canvas engagements are invalid.',
	9018: 'One or more Related engagement Codes are invalid.',
	9019: "Les pourcentages des projets doivent être supérieurs à zéro.",
	9020: "Les pourcentages des projets ne peuvent pas compter plus de deux décimales.",
	9021: "Les taux des projets doivent être supérieurs à zéro.",
	9022: 'L’identifiant du projet est invalide.',
	9023: 'Get call for financial analysis failed.',
	9024: 'Renseignements sur le projet introuvables.',
	9025: 'Échec de la demande de récupération de l’en-tête.',
	9026: 'No results match the search criteria.',
	9027: 'Type de regroupement non valide.',
	9028: 'L’utilisateur actuel n’a pas accès au projet.',
	9029: 'Renseignements sur la facturation du projet introuvables.',
	9030: "Project Financial Filters not found.",
	9031: "A user's name is either too long or too short.",
	9032: "A user's GUI is invalid.",
	9033: "A user's email address is either too long or too short.",
	9034: 'At least one team member should have project administrator role.',
	9035: 'Vous êtes le dernier administrateur actif du projet. Supprimez le projet pour le retirer de votre page d’accueil. Si vous ne pouvez pas le supprimer, veuillez communiquer avec le Service de dépannage.',
	9036: 'Please remove some EY Canvas Engagement because the quantity exceeds the {0}.',
	9037: 'Please remove some team members because the quantity exceeds the {0}.',
	9038: 'Please remove some Engagement codes because the quantity exceeds the {0}.',
	9039: 'Le nombre d’utilisateurs pour le projet doit être supérieur à zéro.',
	9040: 'Unvalidated Financial Codes must not be null or empty strings, and their length cannot surpass 50 characters.',
	9041: 'Le champ de l’identifiant du projet ne doit pas être vide.',
	9042: 'Suppression impossible. Veuillez réessayer et si l’erreur persiste, communiquez avec le Service de dépannage.',
	9043: 'L’utilisateur actuel n’a pas les droits pour modifier le projet.',
	9044: 'Project Financial Details call failed.',
	9045: 'Project status is not valid.',
	9046: 'Project user status is not valid.',
	9047: 'Invalid project user role.',
	9048: 'Project name should be within 500 characters.',
	9049: 'Project user first name cannot be empty.',
	9050: 'Project user last name cannot be empty.',
	9051: 'Project user GUI cannot be empty.',
	9052: 'Project user email cannot be empty.',
	9053: 'Project user admin flag cannot be empty.',
	9054: 'Priviledged account cannot be added as project user.',
	9055: 'Project Expense Filters not found.',
	9056: 'Project indepedence patch request body cannot be empty.',
	9058: 'Financial codes is invalid.',
	9063: 'Independence complete has invalid rationale value.',
	9064: 'Independence complete type has invalid value.',
	9065: 'Project Expense Filters not found.',
	9066: 'Number of engagement ids linked to the project is greater than the maximum allowed number.',
	9067: 'Invalid patch operation.',
	9068: 'Some user already updated the status, refresh the page to view the latest status.',
	9069: 'Independence patch API failed.',
	9070: 'Duplicate financial codes associated to canvas engagement.',
	9071: 'Only single financial codes associated to canvas engagement can be marked as primary code.',
	9072: 'Primary financial codes associated to canvas engagements is invalid.',
	9073: 'Duplicate unvalidated financial codes.',
	9074: 'Duplicate users.',
	9075: 'A user Email is invalid.',
	9076: 'Engagement user creater request body cannot be empty.',
	9077: 'Engagement user create request has duplicate users.',
	9078: 'Engagement user role is invalid.',
	9079: 'Invalid canvas engagement.',
	9080: 'Engagement not mapped to project.',
	9081: 'Engagement user creation request failed.',
	9082: 'Session has been timed out due to inactivity. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*Admin error codes*/
	14001: 'User not found',
	14002: 'Admin User call failed',
	14003: 'Admin user found is InActive',
	14004: 'Admin user creation failed',
	14005: 'The first name is either too short or too long. Please try again',
	14006: 'The last name is either too short or too long. Please try again',
	14007: 'Administrator role id is invalid',
	14008: 'The selected user is already an administrator. Please review.',
	14009: 'Admin user search call failed',
	14010: 'User gui cannot be empty',
	14011: 'User gui must be greater than zero',
	14012: 'User id is not valid. Please try again',
	14013: 'Email address is not valid. Please try again',
	14014: 'Logged in user is not same as admin user',
	14015: 'Admin project search call failed',
	14016: 'Admin user already exists but is InActive',
	14017: 'Admin can only be priviledged user account',
	14018: 'Administrator role id cannot be empty.',
	14019: 'Logged in user is not system admin.',
	14020: 'Invaid requestor privileged account.',
	14021: 'Admin can only be priviledged user account.',
	14023: 'Error removing existing admin roles.',
	14024: 'Error adding updated admin roles.',
	14025: 'Admin user id cannot be empty.',

	/*PAANS error codes*/
	15001: 'The EY Policy Authoring, Approvals and Notification Service​ is unavailable at this time.  We are unable to confirm if all relevant policies have been completed.  If you have not reviewed the relevant policies, refresh the page and try again.  If the issue persists, contact the Help Desk.'
};
export const roundingOptions = [{
		value: 'none',
		label: 'aucun'
	},
	{
		value: 'thousands',
		label: 'En milliers'
	},
	{
		value: 'millions',
		label: 'En millions'
	},
	{
		value: 'lakhs',
		label: 'En lakhs'
	},
	{
		value: 'crores',
		label: 'En crores'
	}
];

export const displayLanguages = [{
		displayLanguageId: 1,
		label: 'Anglais',
		value: 'en-us'
	},
	{
		displayLanguageId: 4,
		label: 'Français',
		value: 'fr-ca'
	},
	{
		displayLanguageId: 5,
		label: 'Espagnol',
		value: 'es'
	},
	{
		displayLanguageId: 7,
		label: 'Portugais',
		value: 'pt-br'
	},
	{
		displayLanguageId: 8,
		label: 'Japonais',
		value: 'ja'
	},
	{
		displayLanguageId: 9,
		label: 'Mandarin – Chine',
		value: 'zh-cn'
	},
	{
		displayLanguageId: 10,
		label: 'Mandarin – Taïwan',
		value: 'zh-tw'
	},
	{
		displayLanguageId: 11,
		label: 'Hébreu',
		value: 'he'
	},
	{
		displayLanguageId: 12,
		label: 'Coréen',
		value: 'ko'
	},
];

export const numberFormats = [{
		value: '1,234,567,890',
		label: 'numbericStlye1',
		title: '1,234,567,890'
	},
	{
		value: '1.234.567.890',
		label: 'numbericStlye3',
		title: '1.234.567.890'
	},
	{
		value: '1,23,45,67,890',
		label: 'numbericStlye7',
		title: '1,23,45,67,890'
	},
	{
		value: '1 234 567 890',
		label: 'numbericStlye2',
		title: '1 234 567 890'
	}
];

export const dateFormats = [{
		value: 'MM/dd/yyyy',
		label: 'MM/DD/YYYY'
	},
	{
		value: 'dd/MM/yyyy',
		label: 'DD/MM/YYYY'
	},
	{
		value: 'yyyy/MM/dd',
		label: 'YYYY/MM/DD'
	}
];

export const negativeNumberFormats = [{
		value: '(1.1)',
		label: '(1.1)'
	},
	{
		value: '-1.1',
		label: '-1.1'
	},
	{
		value: '- 1.1',
		label: '- 1.1'
	},
	{
		value: '1.1-',
		label: '1.1-'
	},
	{
		value: '1.1 -',
		label: '1.1 -'
	}
];

export const currencyFormats = [{
		value: 'mondial',
		label: 'Mondial'
	},
	{
		value: 'local',
		label: 'Local'
	}
];

export const themeOptions = {
	light: 'Clair',
	dark: 'Sombre'
};

export const currencyOptions = {
	global: 'Mondiale',
	local: 'Locale'
};

export const currencyDisplayOptions = [{
		value: 'Global',
		label: 'Mondial'
	},
	{
		value: 'Local',
		label: 'Local'
	}
];

export const statusValues = [{
		isActive: true,
		label: 'Active'
	},
	{
		isActive: false,
		label: 'Inactive'
	}
];

export const financialOptions = {
	serviceLine: 'Gamme de services',
	subServiceLine: 'Sous-gamme de services',
	teamMember: 'Membre de l’équipe',
	rank: 'Échelon'
};

export const roles = {
	1: 'Associé responsable',
	2: 'Associé responsable de la mission',
	3: 'Directeur',
	4: 'Principal/Associé délégué',
	5: 'Chef d’équipe senior',
	6: 'Chef d’équipe',
	7: 'Comptable senior',
	8: 'Comptable stagiaire',
	9: 'Étudiant stagiaire',
	10: 'Responsable du contrôle qualité de la mission',
	11: 'Autre associé',
	12: 'Groupe PSM – Comptable stagiaire',
	13: 'Services consultatifs (groupe Risque et certification en TI, SCT, Capital humain ou autre)',
	14: 'Fiscalité',
	15: 'Services de soutien aux cadres',
	16: 'Affaires juridiques',
	17: 'Responsable du contrôle qualité de l’audit',
	21: 'Superviseur de la fonction d’audit interne',
	22: 'Personnel de la fonction d’audit interne',
	23: 'Autorité de réglementation',
	24: 'Autre (p. ex., revue de contrôle préalable)',
	25: 'Bureau',
	26: 'Zone',
	27: "Secteur d'activité",
	28: 'National',
	29: 'Mondial',
	30: 'Groupe PSM – Professionnel senior',
	31: 'Groupe PSM – Chef d’équipe'
};

export const serviceLines = [{
		value: 0,
		label: 'Toutes les gammes de service'
	},
	{
		value: 1,
		label: 'Consultation'
	},
	{
		value: 2,
		label: 'Certification'
	},
	{
		value: 3,
		label: 'Bureau mondial de la conformité'
	},
	{
		value: 4,
		label: 'SCT'
	},
	{
		value: 5,
		label: 'Fiscalité'
	},
	{
		value: 6,
		label: 'Autre'
	}
];

export const serviceLinesByServiceLineCode = [{
		code: 'Not available',
		label: 'Not available'
	},
	{
		code: null,
		label: 'Allocation'
	},
	{
		code: 'ASU',
		label: 'Certification'
	},
	{
		code: 'TAS',
		label: 'Strategy and Transactions'
	},
	{
		code: 'TAX',
		label: 'Fiscalité'
	},
	{
		code: 'ADV',
		label: 'Consulting'
	},
];

export const userRanks = [{
		id: '11',
		name: 'Associé'
	},
	{
		id: '12',
		name: 'Associé'
	},
	{
		id: '13',
		name: 'Associé délégué'
	},
	{
		id: '21',
		name: 'Chef d’équipe senior'
	},
	{
		id: '32',
		name: 'Chef d’équipe'
	},
	{
		id: '36',
		name: 'Chef d’équipe, Fiscalité'
	},
	{
		id: '4',
		name: 'Sous-traitant'
	},
	{
		id: '41',
		name: 'Senior 3'
	},
	{
		id: '42',
		name: 'Senior'
	},
	{
		id: '43',
		name: 'Stagiaire 2'
	},
	{
		id: '44',
		name: 'Stagiaire'
	},
	{
		id: '45',
		name: 'Senior 2'
	},
	{
		id: '46',
		name: 'Stagiaire 3'
	},
	{
		id: '49',
		name: 'Conseiller'
	},
	{
		id: '5',
		name: 'Administrative contractor'
	},
	{
		id: '51',
		name: 'Étudiant stagiaire'
	},
	{
		id: '52',
		name: 'Soutien administratif'
	},
	{
		id: '53',
		name: 'Stagiaire (SBE)'
	},
	{
		id: '55',
		name: 'Responsable administratif'
	},
	{
		id: '56',
		name: 'Admin - senior'
	},
	{
		id: '57',
		name: 'Admin - intermédiaire'
	},
	{
		id: '58',
		name: 'Admin - junior'
	},
	{
		id: '61',
		name: 'Directeur'
	},
	{
		id: '62',
		name: 'Codirecteur'
	},
	{
		id: '63',
		name: 'Directeur adjoint'
	},
	{
		id: '64',
		name: 'Conseilller superviseur'
	},
	{
		id: '65',
		name: 'Conseiller senior'
	},
	{
		id: '66',
		name: 'Conseiller'
	},
	{
		id: 'Not available',
		name: 'Not available'
	},
	{
		id: null,
		name: 'Allocation'
	},
];

export const financialAnalysis = {
	noResultFound: 'Aucun résultat pour les options sélectionnées',
	allServiceLines: 'Toutes les gammes de service',
	allSubServiceLines: 'Toutes les sous-gammes de service',
	allMembers: 'Tous les membres',
	allAvailable: 'Tous les membres disponibles',
	allAdded: 'Tous les membres ajoutés',
	selectAll: 'Tout sélectionner',
	noResult: 'Aucun résultat trouvé',
	noneSelected: 'Aucune sélection',
	clearAllSeleted: 'Effacer la sélection',
	showSelected: 'Afficher la sélection',
	allRanks: 'Tous les échelons'
};

export const independenceStatus = [{
		value: 1,
		label: 'Incomplete - Not invited'
	},
	{
		value: 2,
		label: 'Incomplete - In progress'
	},
	{
		value: 3,
		label: 'Completed - Other'
	},
	{
		value: 4,
		label: 'Completed - Validated In EY Canvas'
	}
];

export const eycanvasIndependenceStatus = [{
		value: 1,
		label: 'Incomplete'
	},
	{
		value: 2,
		label: 'No Matters Identified'
	},
	{
		value: 3,
		label: 'Matter Identified - Pending Action'
	},
	{
		value: 4,
		label: 'Matter Resolved - Denied Access'
	},
	{
		value: 5,
		label: 'Matter Resolved - Granted Access'
	},
	{
		value: 6,
		label: 'Not Applicable'
	},
	{
		value: 7,
		label: 'Restored'
	},
	{
		value: 8,
		label: 'Override'
	},
	{
		value: 9,
		label: 'Prior - No Matters Identified'
	},
	{
		value: 10,
		label: 'Prior - Matter Identified - Pending Action'
	},
	{
		value: 11,
		label: 'Prior - Matter Resolved - Granted Access'
	},
	{
		value: 12,
		label: 'Prior - Matter Resolved - Denied Access'
	}
];

export const eycanvasIndependenceStatusAvailableOnUI = [{
		value: 1,
		label: 'Incomplete'
	},
	{
		value: 2,
		label: 'No Matters Identified'
	},
	{
		value: 3,
		label: 'Matter Identified - Pending Action'
	},
	{
		value: 4,
		label: 'Matter Resolved - Denied Access'
	},
	{
		value: 5,
		label: 'Matter Resolved - Granted Access'
	},
	{
		value: 6,
		label: 'Not Applicable'
	},
	{
		value: 7,
		label: 'Restored'
	},
	{
		value: 8,
		label: 'Override'
	},
	{
		value: 9,
		label: 'Prior - No Matters Identified'
	},
	{
		value: 11,
		label: 'Prior - Matter Resolved - Granted Access'
	},
	{
		value: 12,
		label: 'Prior - Matter Resolved - Denied Access'
	},
	{
		value: 13,
		label: 'Not Invited'
	}
];

export const availableUserRoles = [{
	  value: 1,
	  label: 'Partner in Charge',
	  displayOrder: 9
  },
  {
	  value: 2,
	  label: 'Engagement Partner',
	  displayOrder: 8
  },
  {
	  value: 3,
	  label: 'Executive Director',
	  displayOrder: 5
  },
  {
	  value: 4,
	  label: 'Principal',
	  displayOrder: 6
  },
  {
	  value: 5,
	  label: 'Senior Manager',
	  displayOrder: 4
  },
  {
	  value: 6,
	  label: 'Manager',
	  displayOrder: 3
  },
  {
	  value: 7,
	  label: 'Senior',
	  displayOrder: 2
  },
  {
	  value: 8,
	  label: 'Staff',
	  displayOrder: 1
  },
  {
	  value: 10,
	  label: 'Engagement Quality Reviewer',
	  displayOrder: 10
  },
  {
	  value: 11,
	  label: 'Other Partner',
	  displayOrder: 7
  },
  {
	  value: 12,
	  label: 'GDS - Staff',
	  displayOrder: 13
  },
  {
	  value: 16,
	  label: 'General Counsel',
	  displayOrder: 12
  },
  {
	  value: 17,
	  label: 'Audit Quality Reviewer',
	  displayOrder: 11
  },
  {
	  value: 30,
	  label: 'GDS - Senior',
	  displayOrder: 14
  },
  {
	  value: 31,
	  label: 'GDS - Manager',
	  displayOrder: 15
  }
]

export const employmentStatusFilter = [{
		value: 'A',
		label: 'Active'
	},
	{
		value: 'L,P,U',
		label: 'Leave of absence'
	},
	{
		value: 'D,R,T',
		label: 'Terminated'
	}
]

export const employmentStatus = [{
		value: 'A',
		label: 'Active'
	},
	{
		value: 'D',
		label: 'Terminated'
	},
	{
		value: 'L',
		label: 'Leave of absence'
	},
	{
		value: 'T',
		label: 'Terminated'
	},
	{
		value: 'P',
		label: 'Leave of absence'
	},
	{
		value: 'R',
		label: 'Terminated'
	},
	{
		value: 'U',
		label: 'Leave of absence'
	},
]

export const independenceStatusDropdown = [{
		label: 'Incomplete',
		options: [{
				value: 1,
				label: 'Incomplete - Not invited'
			},
			{
				value: 2,
				label: 'Incomplete - In progress'
			}
		]
	},
	{
		label: 'Complete',
		options: [{
				value: 3,
				label: 'Completed - Other'
			}
		]
	}
];

export const customizedTableOptions = [{
		id: 2,
		label: 'EY Canvas independence status'
	},
	{
		id: 3,
		label: 'Member firm'
	},
	{
		id: 4,
		label: 'Country'
	},
	{
		id: 5,
		label: 'Hours charged'
	},
	{
		id: 6,
		label: 'Overall independence status'
	},
	{
		id: 7,
		label: 'Confirmation date'
	},
	{
		id: 8,
		label: 'Employment Status'
	},
	{
		id: 9,
		label: 'Updated by'
	},
	{
		id: 10,
		label: 'Updated date'
	}
];

export const independenceStatusChangeReasons = [{
		value: 1,
		label: 'Completed outside of EY Canvas - No Matters Identified',
		isDisplayed: true
	},
	{
		value: 7,
		label: 'Completed outside of EY Canvas - Matters Identified',
		isDisplayed: true
	},
	{
		value: 8,
		label: 'Completed outside of EY Canvas - Matters Resolved',
		isDisplayed: true
	},
	{
		value: 2,
		label: 'Always a covered person',
		isDisplayed: true
	},
	{
		value: 3,
		label: 'No longer with the Firm',
		isDisplayed: true
	},
	{
		value: 4,
		label: 'Leave of absence',
		isDisplayed: true
	},
	{
		value: 5,
		label: 'Terminated',
		isDisplayed: false
	},
	{
		value: 6,
		label: 'Autre',
		isDisplayed: false
	}
];

export const common = {
	selected: 'Sélectionnée',
	cancel: 'Annuler',
	checkbox: {
		selectAllOn: 'Tout sélectionner',
		selectAllOff: 'Tout désélectionner'
	},
	clear: 'Effacer',
	close: 'Fermer',
	nav: {
		projectName: 'Project name'
	},
	pagination: {
		show: 'Afficher',
		iconHover: {
			first: 'Première page',
			previous: 'Page précédente',
			next: 'Page suivante',
			last: 'Dernière page'
		}
	},
	search: {
		clear: 'Effacer la recherche',
		buttonTitle: 'Rechercher',
		placeholder: 'Rechercher',
		noResultsPlaceholder: 'Aucun résultat trouvé'
	},
	table: {
		remove: 'Supprimer',
		noDataPlaceholder: 'Aucune donnée disponible',
		noResultsPlaceholder: 'Aucun résultat trouvé'
	},
	toggleSwitch: {
		no: 'Non',
		yes: 'Oui'
	},
	wizard: {
		next: 'Continuer',
		back: 'Retour',
		finish: 'Terminer'
	},
	unsavedChanges: 'Unsaved changes',
	unsavedChangesDescription: 'You have unsaved changes that will be lost if you choose to continue. Are you sure you want to undo your changes?'
};

export const project = {
	myProjects: 'Mes projets',
	priorProjects: 'Projets précédents',
	searchForBudgets: 'Rechercher',
	emptyContainer: 'Vous n’avez aucun budget actif. Veuillez cliquer sur «Créer un budget» pour commencer.',
	noResultsFound: 'Aucun résultat trouvé.',
	create: {
		title: 'Créer un projet',
		clientCode: 'Code client',
		clientCodeInfo: 'Les codes miroirs ne sont pas reconnus. Veuillez utiliser le code généré par le système (c.-à-d.,  Mercury ou GFIS).',
		clientName: 'Nom du client',
		clientNamePlaceholder: 'Saisir le code client pour chercher un nom de client',
		name: 'Nom du projet',
		rate: 'Taux horaire par défaut',
		rateInfo: 'Le taux horaire par défaut sera utilisé pour calculer la valeur des heures budgétées. Ce taux devrait être calculé en divisant les honoraires à facturer par le total des heures prévues.',
		percentage: 'Pourcentage de réalisation attendu.',
		percentageInfo: 'Le pourcentage de réalisation attendu sera appliqué à la valeur temporelle des heures facturées dans Mercury ou dans le GFIS.',
		relateEngagementsInstructionalText: 'Sélectionner une ou plusieurs missions EY Canvas qui seront utilisées dans ce projet. Les mesures tirées de ces missions seront présentées avec les données financières. Seules les missions actuellement accessibles seront affichées.',
		selectClientAndWorkspaceInstructionalText: 'Sélectionner un client et un espace de travail pour trouver les missions EY Canvas qui seront associées à ce projet.',
		engagementPanelPlaceholder: 'Sélectionner un client et un espace de travail pour afficher les missions suggérées.',
		engagementPanelNoResultsFound: 'Aucun résultat trouvé',
		emptyEngagements: 'Aucune mission EY Canvas disponible. Créer une nouvelle mission dans EY Canvas pour commencer.',
		selectClient: 'Sélectionner un client',
		selectWorkspace: 'Sélectionner un espace de travail',
		selectEngagements: 'Sélectionner une mission',
		selectedEngagements: 'Missions ajoutées',
		selectedEngagementError: 'Sélectionner une ou plusieurs missions pour continuer',
		searchEngagements: 'Rechercher des missions',
		searchUsers: 'Rechercher des utilisateurs',
		engagementLabel: '{0} | Identifiant : {1}',
		addBtn: 'Ajouter',
		removeBtn: 'Supprimer',
		clientLbl: 'Client',
		engagementCodeLbl: 'Code mission',
		engagementTypeCodeLbl: 'Type de mission',
		engagementNameLbl: 'Nom de la mission',
		engagementId: 'Identifiant',
		addedByLbl: 'Ajoutée par',
		engagementDescriptionLbl: 'Description de la mission',
		systemLbl: 'Système',
		noEngagementsLabel: 'Associer des codes mission à ce projet.',
		step4InstTxt: 'Sélectionner un ou plusieurs codes de mission devant être associés au projet.',
		relatedEngagementCodesSubtitle: 'Codes mission associés',
		relatedEngagementCodeLink: 'Associer un code mission de Mercury ou du GFIS. Codes miroirs non reconnus.',
		unauthorizedModalHeader: 'Utilisateur non autorisé',
		unauthorizedText: 'Vous n’êtes pas autorisé(e) à associer',
		allowedUsersText: 'Voici la liste des personnes qui sont autorisées à effectuer cette action.',
		closeBtn: 'Fermer',
		validateBtn: 'Valider',
		relatedEngagementAddLabel: 'Associer un code mission de Mercury ou du GFIS. Codes miroirs non reconnus.',
		todayLbl: 'Aujourd’hui',
		NoEmailMessage: 'Aucune adresse courriel fournie',
		noEngagementsAdded: 'Aucune mission ajoutée',
		selectToImport: 'Sélectionner une mission EY Canvas pour importer des utilisateurs dans ce projet.',
		addMember: 'If a user is not active in the EY Canvas engagement, {0} to add them.',
		addedMembers: 'Membres ajoutés',
		employeeName: 'Membre',
		role: 'Rôle',
		manageTeamInstructionalText: 'Sélectionnez des membres actifs à partir des missions EY Canvas associées, suivez les instructions ci-après pour ajouter d’autres membres qui ne font pas partie des missions EY Canvas.',
		currentUser: 'Utilisateur actuel',
		canvasEngagements: 'EY Canvas engagements',
		wizardSteps: [{
				stepName: 'Étape 1',
				stepDescription: 'Entrer les détails sur le projet',
				active: true
			},
			{
				stepName: 'Étape 2',
				stepDescription: 'Select EY Canvas engagements'
			},
			{
				stepName: 'Étape 3',
				stepDescription: 'Gérer l’accès',
				relatedEngagementCodesSubtitle: 'Codes mission associés',
				relatedEngagementCodeLink: 'Associer un code mission de Mercury ou du GFIS. Codes miroirs non reconnus.',
				unauthorizedModalHeader: 'Utilisateur non autorisé',
				unauthorizedText: 'Vous n’êtes pas autorisé(e) à associer',
				allowedUsersText: 'Voici la liste des personnes qui sont autorisées à effectuer cette action.',
				close: 'Fermer'
			},
			{
				stepName: 'Étape 4',
				stepDescription: 'Se connecter à Mercury/GFIS'
			},
			{
				stepName: 'Step 5',
				stepDescription: 'Associate engagement codes to EY Canvas engagements',
				isExit: true
			}
		],
		ratePerHour: 'Taux horaire',
		realizationPercentage: 'Pourcentage de réalisation'
	},
	stepOne: {
		enterProjectName: 'Entrer un nom de projet pour continuer'
	},
	stepTwo: {
		addCanvasEngagements: 'Add EY Canvas engagements to the project',
		editCanvasEngagements: 'Edit EY Canvas engagements to the project',
		selectCanvasEngagements: 'EY Canvas engagements that you have access to are displayed.  Select one or more EY Canvas engagements to be included in the project.',
		noCanvasEngagements: 'No EY Canvas engagements available. Proceed to the next step to continue project setup.',
		noCanvasEngagementsSelected: 'No EY Canvas engagements have been selected',
		noSearchResultsFoundLeftRail: 'No results found',
		clientName: 'Client',
		workspace: 'Espace de travail',
		engagementCode: 'Code mission',
		canvasEngagementName: 'EY Canvas Engagement',
		changes: 'Modifications',
		tooltipMessages: {
			clientName: 'Nom du client',
			clientCode: 'Code client',
			engagementCode: 'Code mission',
			engagementDescription: 'Nom de la mission',
			workspaceID: 'Identifiant de l’espace de travail',
			workspaceDescription: 'Nom de l’espace de travail'
		}
	},
	stepThree: {
		editTeamMembers: 'Modifier les membres de l’équipe participant au projet',
		editTeamMembersWhoWillHaveAccess: 'Edit team members who will have access to the project. To add a team member who is not part of the associated EY Canvas engagements, use the search feature on the right-hand side. Project administrators will have the ability to manage the project (e.g., add or remove team members).',
		addTeamMembers: 'Ajouter des membres au projet',
		addTeamMembersWhoWillHaveAccess: 'Add team members who will have access to the project. To add a team member who is not part of the associated EY Canvas engagements, use the search feature on the right-hand side. Project administrators will have the ability to manage the project (e.g., add or remove team members).',
		noCanvasEngagementsSelected: 'No EY Canvas engagements have been selected',
		noSearchResultsFoundLeftRail: 'No results found',
		addOtherTeamMembers: 'Add other team members not part of the connected EY Canvas engagements',
		member: 'Membre',
		projectAdministrator: 'Administrateur de projet',
		clickHere: 'cliquer ici',
		nameOrEmail: 'Nom ou courriel',
		addNewMember: 'Ajouter',
		firstName: 'Prénom',
		lastName: 'Nom de famille',
		inviteAndClose: "Inviter et fermer''",
		inviteAndAddAnother: 'Inviter et ajouter un autre membre',
		clear: 'Effacer'
	},
	stepFour: {
		engagementCode: 'Code mission',
		clientName: 'Client',
		validation: 'État',
		independenceOnly: 'Independence only',
		noEngagementCodes: 'Aucun code mission ajouté au projet',
		addNewMember: 'Ajouter',
		addEngagementManually: 'Ajouter des codes mission',
		addEngagementCodes: 'Ajouter des codes mission',
		editEngagementCodes: 'Modifier les codes de mission',
		validateEngagement: 'Validate all the engagement codes added. Only engagements codes that you have access to in GFIS/Mercury can be validated. If an engagement code is identified as \'Independence only\', details related to this engagement code (such as team members and related hours charged) will be included in the Independence summary of this Economics project but will not be included in the financial related information.',
		informationalMessage: 'Pour Mercury, faites précéder le code mission du type de mission (p. ex., E-12345678)',
		noCanvasEngagements: 'No EY Canvas engagements have been added to the project',
		engagementCodePlaceholder: 'Entrer le code mission',
		validate: 'Valider',
		engagementCodeRequired: 'Code mission requis',
		searchNoResults: "Aucun résultat trouvé"
	},
	stepFive: {
		title: 'Associate engagement codes to EY Canvas engagements',
		description: "The primary engagement codes associated to each of the connected EY Canvas engagements are displayed below. To associate additional engagement codes to an EY Canvas engagement, use the below drag and drop functionality.",
		financialCodes: {
			searchButtonTitle: 'Search',
			searchButtonPlaceholder: 'Search by financial engagement code',
			header: 'Engagement codes',
			noRecords: 'No engagement codes identified',
			canvasEngagements: 'EY Canvas engagements',
			noResults: 'Aucun résultat trouvé'
		},        
		canvasEngagements: {
			searchButtonTitle: 'Search',
			clearButtonTitle: 'Clear',
			noResults: 'Aucun résultat trouvé',
			searchButtonPlaceholder: 'Search by Client or EY Canvas engagement',
			header: 'Clients and engagements',
			noRecords: 'No EY Canvas engagements associated to the project',
			noEngagementCodes: 'No associated engagement codes',
			primary: 'Primary',
			displayUnassociatedEngagements:'Display EY Canvas engagement(s) with no financial codes associated'
		}
	},
	deleteProject: 'Supprimer le projet',
	deleteDescription: 'Voulez-vous vraiment supprimer le projet pour tous les utilisateurs?',
	deleteDescText: 'Cette action ne peut pas être annulée.',
	delete: 'Supprimer',
	cancel: 'Annuler',
	close: 'Fermer',
	confirm: 'Confirmer',
	leaveProject: 'Quitter',
	leaveDescription: 'Voulez-vous vraiment quitter ce projet? Les membres de votre équipe y auront toujours accès.',
	change: 'modification',
	changes: 'modifications'
};

export const users = {
	settings: {
		title: 'Paramètres de l’utilisateur',
		firstName: 'Prénom',
		lastName: 'Nom de famille',
		displayLanguage: 'Langue d’affichage',
		numberFormat: 'Format des nombres',
		negativeNumberFormat: 'Format des nombres négatifs',
		currencyFormat: 'Format de la devise',
		dateFormat: 'Format de la date',
		roundingFormat: 'Format de l’arrondissement',
		save: 'Enregistrer',
		cancel: 'Annuler',
		errorMessageSelect: 'Veuillez sélectionner une valeur.',
		errorMessageInput: 'Veuillez entrer une valeur valide.',
		isRequired: 'est un champ requis',
		preferences: 'Préférences',
		yourDelegates: 'Vos délégués',
		yourDelegatesDescription: 'Utilisateurs que vous avez autorisés à récupérer les données financières associées aux codes mandat auxquels vous avez accès dans Mercury ou le GFIS.',
		delegationsFromOthers: 'Vos accès à titre de délégué',
		delegationsFromOthersDescription: 'Utilisateurs qui vous ont autorisé(e) à récupérer les données financières associées aux codes mandat auxquels ils ont accès dans Mercury ou le GFIS.',
		noUsersIdentified: 'Aucun utilisateur identifié',
		addADelegate: 'Ajouter un délégué',
		theme: 'Thème',
		preferredCurrency: 'Devise à utiliser',
		status: 'État'
	}
};

export const projectSummary = {
	filter: {
		filterFinancialAuditData: 'Filtrer les clients',
		filter: 'Filtrer',
		searchPlaceholder: 'Rechercher',
		searchClearHoverText: 'Effacer',
		searchHoverText: 'Rechercher',
		unvalidated: 'Non validé',
		noData: 'No EY Canvas engagement associated',
		noResults: 'Aucun résultat trouvé',
		noInformationAvailable: 'Aucune information disponible pour les options sélectionnées',
		independence: 'Independence',
		noDataFound: 'No data found',
	},
	roundingType: 'Arrondissement :',
	roundingFormats: {
		none: 'Aucun',
		thousands: 'En milliers',
		millions: 'En millions',
		lakhs: 'En lakhs',
		crores: 'En crores'
	},
	updatedDateType: {
		financialDateLabel: 'Financial data',
		updatedOn: 'updated on',
		canvasDateLabel: 'EY Canvas data'
	},
	keyPerformanceIndicators: {
		noValue: '-',
		totalEngagementRevenue: {
			ter: 'TER',
			actualTER: 'TER réel',
			billed: 'Facturés',
			actualBilling: 'Honoraires facturés',
			totalEngagementRevenue: 'Total des revenus tirés de la mission (TER) (honoraires + dépenses)',
			forecastedTER: 'TER prévu'
		},
		margin: {
			margin: 'Marge',
			target: 'Cible'
		},
		globalDeliveryService: {
			gds: 'Recours au groupe PSM',
			globalDeliveryService: 'Prestation de services mondiaux'
		}
	},
	currency: 'Devise :',
	globalCurrency: 'Mondiale',
	localCurrency: 'Locale',
	noDataAvailable: 'Aucune donnée disponible pour les filtres sélectionnés.',
	actualHours: 'Heures réelles',
	etc: 'Estimation à l’achèvement',
	ftaVariance: 'Écart entre les prévisions et les données réelles',
	completedTasks: 'Tâches terminées',
	closedAssignments: 'Affectations fermées',
	acceptedRequests: 'Demandes acceptées',
	gDSUsage: 'Recours au groupe PSM',
	summaryHeaderPartner: 'Associé',
	summaryHeaderPpedd: 'Associés, associés délégués ou directeurs',
	summaryHeaderExecutive: 'Cadre',
	financialProgressCard: {
		financialProgress: 'Progrès financiers',
		financialDetails: 'Données financières',
		ansr: 'ANSR',
		nsr: 'NSR',
		ansrTooltip: 'Adjusted net standard revenue (net fees excluding expenses)',
		nsrTooltip: 'Net standard revenue (individual net standard rates times hours)',
		eafTooltip: 'Engagement adjustment factor',
		cost: 'Coût',
		hours: 'Heures',
		expandDetails: 'Afficher plus de détails',
		expand: 'Développer',
		collapse: 'Collapse',
		collapseDetails: 'Collapse details',
		margin: 'Marge',
		marginPercentage: 'Marge',
		rphAcronym: 'Taux horaire',
		cphAcronym: 'Coût horaire',
		mphAcronym: 'Marge horaire',
		eafAcronym: 'EAF',
		actual: 'Réel',
		budgeted: 'Budgété',
		forecasted: 'Prévisions',
		ftaVariance: 'Écart entre les prévisions et les données réelles',
		ftaVarianceTooltip: 'Écart entre les prévisions et les données réelles',
		rph: 'Taux horaire',
		cph: 'Coût horaire',
		mph: 'Marge horaire',
		ansrCost: 'NSR / Cost',
		serviceLine: 'Gamme de services',
		subServiceLine: 'Sous-gamme de services',
		teamMember: 'Membre de l’équipe',
		totalAnsr: 'Total NSR',
		totalCost: 'Total des coûts',
		totalHours: 'Total des heures',
		ansrLabelText: 'Net standard revenue',
		rank: 'Échelon',
		performanceActuals: 'Performance actuals'
	},
	financialAnalysis: {
		show: 'Afficher',
		first: 'Première page',
		last: 'Dernière page',
		previous: 'Précédent',
		next: 'Suivant'
	},
	financialFilters: {
		serviceLine: 'Gamme de services',
		subServiceLine: 'Sous-gamme de services',
		rank: 'Échelon',
		teamMember: 'Membre de l’équipe',
		showMore: 'Plus',
		clear: 'Effacer',
		clearAll: 'Tout effacer',
		search: 'Rechercher',
		noResultsPlaceholder: 'Aucun résultat',
		noFiltersAvailable: 'Aucun filtre',
		yes: 'Oui',
		no: 'Non',
		tooltip: 'Filtrer',
		expenseType: 'Expense type',
		allocation: 'Allocation'
	},
	billingAndExpenses: {
		title: 'Honoraires facturés jusqu’à maintenant',
		forecastedTer: 'TER prévu',
		forecastedTerTooltip: 'Forecasted total engagement revenue (fees + expenses)',
		forecastedBilling: 'Honoraires prévus',
		collected: 'Recouvrés',
		collectedTooltip:'Collected / Billed',
		unCollected: 'Uncollected',
		unCollectedTooltip:'Uncollected / Billed',
		billed: 'Billed (Outstanding)',
		billedTooltip:'Billed / Forecasted TER',
		billedTotal: 'Billed',
		unbilled: 'Non facturés',
		unbilledTooltip: 'Unbilled / Forecasted TER',
		engagementCode: 'Code mission',
		invoiceDate: 'Invoice date',
		currency: 'Currency',
		invoiceNumber: 'Invoice number',
		amount: 'Amount',
		noInformationPlaceholder: 'No information available for the selected options.',
		actualTer: 'Actual TER',
		actualTerTooltip: 'Actual total engagement revenue (fees + expenses)',
		actualExpenseToDate: 'Actual expenses to date',
		displayBy: 'Afficher les données par',
		expenseType: 'Expense type',
		teamMember: 'Membre de l’équipe',
		totalExpenseToDate: 'Total expenses to date',
		expenseTypeColumn: 'Expense type',
		teamMemberColumn : 'Team member',
		globalExpenseAmount: 'Global expense amount',
		localExpenseAmount: 'Local expense amount',
		billingSummary: 'Billing summary',
		billingStatus: 'Billing status',
		billingTER: 'TER',
		serviceLine: 'Gamme de services',
		serviceLineColumn: 'Service line',
		rank: 'Échelon',
		rankColumn : 'Rank',
		allocation: 'Allocation',
		allocationsExpense: 'Allocated expenses present',
	},
	independence: {
		teamMember: 'Membre de l’équipe',
		hoursCharged: 'Hours charged',
		independenceStatus: 'Overall independence status',
		confirmationDate: 'Confirmation date',
		memberFirm: 'Member firm',
		eyCanvasIndependenceStatus: 'EY Canvas independence status',
		employmentStatus: 'Employment status',
		country: 'Country',
		updatedBy: 'Updated by',
		updatedDate: 'Updated date',
		selectColumns: 'Select the columns',
		confirmationDateBefore: 'Confirmation date before',
		confirmationDateAfter: 'Confirmation date after',
		excelsummary: 'Summary',
		excelMercury: 'Data from Mercury',
		excelCanvas: 'Data from Canvas',
		name: 'Name',
		gui: 'GUI',
		rank: 'Échelon',
		emailAddress: 'Email address',
		clarification: 'Clarification',
		explanation: 'Explanation',
		updatedOn: 'Updated on',
		client: 'Client',
		mercuryEngagementCode: 'Mercury engagement code',
		canvasEngagement: 'Canvas engagement',
		email: 'Email',
		reason: 'Reason',
		engagementRole: 'Engagement role',
		location: 'Location',
		employeeStatus: 'Employee status',
		noResultsPlaceholder: 'Aucun résultat trouvé',
		filter : {
			unassociatedFinancialCodes : 'Unassociated financial codes',
			unassociatedLabel : 'Unassociated',
			filterHeader: 'Independence filter',
			noFinancialCodeLabel: 'No financial code associated',
			noEngagementLabel: 'No EY Canvas engagement associated',
			expandText: 'Expand',
			collapseText: 'Collapse',
			noDataFound: 'No data found'
		}
	},
	header:{
		hours: 'Heures',
		actualHours: 'Réelles',
		forecastedHours: 'Prévues',
		variance: 'FTA variance',
		other: 'Autre',
		ppedd: 'Associés, associés délégués ou directeurs',
		mgrSrMgr: 'SrMgr/Mgr',
		partnerHours: "Nombre d’heures de l'associé",
		executiveDirector: 'Associé délégué',
		seniorManager: "Chef d'équipe senior",
		manager: "Chef d'équipe",
		senior: 'Professionnel senior',
		staff: 'Stagiaire',
		intern: 'Étudiant stagiaire',
		billed: 'Facturé :',
		ter: 'TER :',
		forecastedTER: 'TER prévu:',
		margin: 'Marge',
		ansr: 'ANSR',
		cost: 'Coût',
		terSection: 'TER',
		billedSection: 'Facturé',
		forecastedTERSection: 'Prévu',
		forecastedTERSectionForHeader: 'Forecasted TER',
		completedTasks: 'Tâches terminées',
		completedAssignments: 'Affectations fermées',
		acceptedRequests: 'Demandes acceptées',
		gdsUsage: 'Recours au groupe PSM',
		completedTasksTooltip: 'Terminées',
		totalTasksTooltip: 'Total',
		completedAssignmentsTooltip: 'Fermées',
		totalAssignmentsTooltip: 'Total',
		acceptedRequestsTooltip: 'Acceptées',
		sentRequestsTooltip: 'Envoyées',
		gdsHoursTooltip: 'PSM',
		actualHoursTooltip: 'Heures réelles',
		otherTooltip: 'Other',
		otherHeaderTooltip: 'Other',
		ppeddTooltip: 'PPEDD',
		mgrSrMgrTooltip: 'SrMgr/Mgr',
		partnerHoursTooltip: 'Partner/Principal',
		executiveDirectorTooltip: 'ED/D',
		seniorManagerTooltip: 'Sr. Manager',
		managerTooltip: 'Manager',
		seniorTooltip: 'Senior',
		staffTooltip: 'Staff',
		internTooltip: 'Intern',
		varianceTooltip: 'Forecast to actual variance',
		ansrTooltip: 'Adjusted net standard revenue (net fees excluding expenses)',
		marginTooltip: 'Margin = (ANSR - Cost) / ANSR',
		terSectionHover: 'Actual total engagement revenue (fees + expenses)',
		forecastedTERSectionHover: 'Forecasted total engagement revenue (fees + expenses)',
		billedSectionHover: 'Actual net invoice amount',
		gdsUsageHover: 'Global Delivery Service usage'
	},
	allocationsFilters : [{
			value: 1,
			label: 'Yes'
		}
	]
};

export const exportOptions = {
	buttonText: 'Exportation',
	downloadCSV: 'Télécharger en format CSV',
	downloadJPEG: 'Télécharger en format JPEG',
	downloadPDF: 'Télécharger en format PDF',
	downloadPNG: 'Télécharger en format PNG',
	downloadSVG: 'Télécharger en format SVG',
	downloadXLS: 'Télécharger en format XLS',
	exitFullscreen: 'Quitter le mode plein écran',
	viewFullscreen: 'Afficher en plein écran',
	printChart: 'Imprimer l’organigramme'
};

export const adminLabels = {
	adminPortal: 'Administration',
	usersTab: 'Manage users',
	projectsTab: 'Manage projects',
	administrators: 'Manage administrators'
};

export const projectUserStatus = {
	active: 'Active',
	inactive: 'Inactive',
};

export const projectUserRoles = {
	defaultUser: 'Default user',
	projectAdministrator: 'Administrateur de projet'
};

export const projectStatus = {
	active: 'Active',
	deleted: 'Deleted'
};

export const administratorRoles = {
	none: 'Aucun',
	adminReader: 'Admin reader',
	adminWriter: 'Admin writer',
	superAdmin: 'Super admin'
}

export const addUser = {
	firstName: 'Prénom',
	lastName: 'Nom de famille',
	enterFirstNameText:'Enter first name, last name or email address of user and press enter to search',
	selectRole: 'Role',
	userRole: 'User role',
	clear: 'Effacer',
	email: 'Email',
	role: 'Rôle',
	cancel: 'Annuler',
	addUser: 'Add User',
	close: 'Fermer',
	add: 'Add',
	addAdministrator: 'Add administrator',
	error1: 'The selected user is already a part of the project. Please review.',
	error2: 'Admin can only be priviledged user account'
};

export const adminManageProjects = {
	manageProjects: 'Manage projects',
	description: 'Search for a project by entering the project ID',
	projectId: 'Project ID',
	search: 'Rechercher',
	clearSearch: 'Clear',
	enterValidProject: 'Enter valid project ID',
	projectDetails: 'Project details',
	enterProjectName: 'Enter project name',
	projectName: 'Project name',
	projectStatus: 'Project status',
	financialCodes: 'Financial codes',
	noFinancialCodes: 'No financial engagement codes are mapped to this project',
	engagementCode: 'Code mission',
	client: 'Client',
	status: 'État',
	validatedBy: 'Validated by',
	canvasEngagements: 'EY Canvas engagements',
	canvasEngagement: 'EY Canvas engagement',
	noCanvasEngagements: 'No EY Canvas engagements are mapped to this project',
	member: 'Members',
	gui: 'GUI',
	firstName: 'Prénom',
	lastName: 'Nom de famille',
	emailAddress: 'Email address',
	userRole: 'User role',
	validated: 'Validated',
	unvalidated: 'Non validé',
	enterValidGui: 'Enter a valid GUI for project ID',
	requiredProjectName: 'Project name cannot be blank',
	successToastMessage: 'Changes saved successfully',
	resetToastMessage: 'Reset completed',
	errorToastMessage: 'At least one project member is required to be a Project administrator. Please review the changes.',
	independenceOnly: 'Independence only',
	yes: 'Oui',
	no: 'Non'
};

export const manageAdministrators = {
	title: 'Manage administrators',
	firstName: 'Prénom',
	lastName: 'Nom de famille',
	email: 'Email',
	role: 'Rôle',
	description: 'Add new administrators or manage existing administrators',
	noInformationPlaceholder: 'No information available for the selected options.',
	updateAdminErrorToast: 'Update was unsuccessful. Please review and try again later.',
	updateAdminSuccessToast: 'Changes saved successfully',
};

export const adminManageUsers = {
	title : 'Manage users',
	description: 'Search for a user by entering their user GUI',
	inputLabel: 'User GUI',
	searchButtonLabel: 'Search',
	cancelButtonLabel: 'Clear',
	errorMessage: 'Enter a valid user GUI',
	userDetails: 'User details',
	projects: 'Projects',
	delegates: 'Delegates',
	settings: 'Settings',
	noResultsPlaceholder: 'No records found',
	delegatedTo: 'Delegated to:',
	delegatedFrom: 'Delegated from:',
	gui: 'GUI',
	firstName: 'Prénom',
	lastName: 'Nom de famille',
	emailAddress: 'Email address',
	projectName: 'Project name',
	projectId: 'Project ID'
};

export const adminCommon = {
	save: 'Enregistrer',
	reset: 'Reset'
}
